"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { useCookieConsent } from "@leabankab/component-library/cookie-consent/react";
import { useRuntimeConfig } from "@/contexts/runtime-config";
import { setGa4AnalyticsConsent, trackGa4Event } from "./ga4";

export const Ga4Init = () => {
	const pathname = usePathname();
	const { consent } = useCookieConsent();
	const { ga4MeasurementId } = useRuntimeConfig();
	const hasTrackedStart = useRef(false);
	const hasAnalyticsConsent = consent?.analytics === true;

	useEffect(() => {
		setGa4AnalyticsConsent(ga4MeasurementId, hasAnalyticsConsent);

		if (
			!hasAnalyticsConsent ||
			!ga4MeasurementId ||
			pathname !== "/" ||
			hasTrackedStart.current
		) {
			return;
		}

		hasTrackedStart.current = true;
		trackGa4Event("loan_application_started");
	}, [ga4MeasurementId, hasAnalyticsConsent, pathname]);

	return null;
};
